import React from 'react';
import { string } from 'prop-types';
import { formatAsPositivePoundsOrPence } from 'utils/currency';
import GoToTrolley from 'components/GoToTrolley';
import { useTrolley } from 'contexts/Trolley';
import TrolleyButtonContents from './TrolleyButtonContents';
import styles from './ShoppingSummary.module.scss';

export const ShoppingSummary = ({ testIdSuffix }) => {
  const { state: trolleyState } = useTrolley();

  const {
    error: hasTrolleyError,
    loading: loadingStatus,
    totalEstimatedCost,
    totalNumberOfItems,
  } = trolleyState;

  const estimatedCost = formatAsPositivePoundsOrPence(totalEstimatedCost);

  const description = `trolley, ${totalNumberOfItems} item${
    totalNumberOfItems !== 1 ? 's' : ''
  } ${estimatedCost} total, view trolley.`;

  return (
    <div className={styles.shoppingSummary}>
      <section
        className={styles.trolleyActions}
        data-actiontype="redirect"
        data-customdata="category:Header"
        data-origincomponent="ShoppingSummary"
        data-shortdescription={hasTrolleyError ? null : description}
      >
        {/* TODO Have GoToTrolley & TrolleyButtonContents components as JSX here if not reused */}
        <GoToTrolley
          label={estimatedCost}
          originComponent="site-header accessible trolley link"
          title={hasTrolleyError ? null : description}
          testIdSuffix={testIdSuffix}
        >
          <TrolleyButtonContents
            hasTrolleyError={hasTrolleyError}
            estimatedCost={estimatedCost}
            loadingStatus={loadingStatus}
            testIdSuffix={testIdSuffix}
          />
        </GoToTrolley>
      </section>
    </div>
  );
};

ShoppingSummary.propTypes = {
  testIdSuffix: string,
};

ShoppingSummary.defaultProps = {
  testIdSuffix: '',
};
